import { ServiceSelectionEnum } from '../../../../../../../core/enums/applications/service-selection-enum';
import { SubmitToEwaFormOption } from '../../shared/models/submit-to-ewa-form-option';

export class PublicSafetyEwaFormOptionConstants {
    static readonly usePublicSafetyCoordinatorAssociatesFormOption: SubmitToEwaFormOption =
        {
            id: 1,
            service: ServiceSelectionEnum.SOLO,
            title: 'Use Public Safety Coordination Associates (PSCA)',
            description:
                "EWA will confirm the accuracy and completeness of the application data and make corrections as necessary to ensure compliance with FCC rules. This application will be forwarded to Public Safety Coordination Associates (PSCA), an IMSA/FCCA collaboration, for final public safety certification.<br><br>EWA will provide a quote for PSCA's frequency coordination and any required inter-service concurrence fees. The status of public safety applications processed through PSCA is tracked within the EWA Cevo dashboard.",
        };
    static readonly useAlternatePublicSafetyCoordinatorFormOption: SubmitToEwaFormOption =
        {
            id: 2,
            service: ServiceSelectionEnum.SOLO,
            title: '(Optional) Choose an Alternate Public Safety Coordinator',
            description:
                '(Optional) I wish to use an alternate certified public safety coordinator. EWA is requested to verify the accuracy of the data I have provided and perform any necessary corrections to ensure compliance with applicable FCC Rules.  Once my application is examined by EWA, I will be contacted about additional charges, such as applicable coordination, FCC, and inter-service fees. I understand I cannot track updates to this application in Cevo after EWA transmits the data to the alternative coordinator of my choice.',
        };

    static formOptions(): SubmitToEwaFormOption[] {
        return [
            this.usePublicSafetyCoordinatorAssociatesFormOption,
            this.useAlternatePublicSafetyCoordinatorFormOption,
        ];
    }
}
